import GENERIC_RELATIONS_NOTICE from './notice/GENERIC_RELATIONS_NOTICE';
import GENERIC_RELATIONS_TEXTBLOCK from './textblock/GENERIC_RELATIONS_TEXTBLOCK';

const GENERIC_RELATIONS_DIALOG_CONFIG = new Map([
  ['notice', GENERIC_RELATIONS_NOTICE],
  ['textblock', GENERIC_RELATIONS_TEXTBLOCK],
]);

export default GENERIC_RELATIONS_DIALOG_CONFIG;
